import React from 'react';

export default function TaxonItem({ name, onClick, expandable = false, expanded = false, onExpand, indent = 0 }) {
    return (
        <div
            className="d-flex align-items-center mb-1"
            style={{ paddingLeft: `${indent * 1.25}rem` }}
        >
            <button
                className="btn btn-sm btn-link p-0 me-2 text-decoration-none text-white btn-auto-width"
                style={{ width: '1.25rem', opacity: expandable ? 1 : 0, pointerEvents: expandable ? 'auto' : 'none' }}
                onClick={e => { e.stopPropagation(); onExpand && onExpand(); }}
            >
                <i className={`fas fa-${expanded ? 'minus' : 'plus'} fa-xs`}/>
            </button>
            <span
                className="fw-bold text-white"
                style={{ cursor: 'pointer', transition: 'background-color .15s ease-in-out' }}
                onMouseEnter={e => e.currentTarget.style.textDecoration = 'underline'}
                onMouseLeave={e => e.currentTarget.style.textDecoration = 'none'}
                onClick={onClick}
            >
                {name}
            </span>
        </div>
    );
}